// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-description-container :is(.block-before, .block-after) .panel-container {
  margin-top: 8px;
  display: flex;
  gap: 4px;
}

.progress-description-container :is(.block-before, .block-after) .section {
  margin-bottom: 24px;
}

.progress-description-container :is(.block-before, .block-after) .section-name {
  margin-bottom: 4px;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.8px;
}

.progress-description-container :is(.block-before, .block-after) .section-value {
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
}

.progress-description-container :is(.block-before, .block-after) .panel-container .indicator {
  background-color: var(--gray);
  height: 8px;
  width: 33%;
  border-radius: 4px;
}

.progress-description-container .block-after .panel-container .indicator {
  background-color: var(--orange);
}

.progress-description-container .line-vertical {
  background-color: var(--light-gray);
  width: 1px;
  margin: 0 20px;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.progress-description.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,UAAU;EACV,cAAc;AAChB","sourcesContent":[".progress-description-container :is(.block-before, .block-after) .panel-container {\n  margin-top: 8px;\n  display: flex;\n  gap: 4px;\n}\n\n.progress-description-container :is(.block-before, .block-after) .section {\n  margin-bottom: 24px;\n}\n\n.progress-description-container :is(.block-before, .block-after) .section-name {\n  margin-bottom: 4px;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20.8px;\n}\n\n.progress-description-container :is(.block-before, .block-after) .section-value {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20.8px;\n}\n\n.progress-description-container :is(.block-before, .block-after) .panel-container .indicator {\n  background-color: var(--gray);\n  height: 8px;\n  width: 33%;\n  border-radius: 4px;\n}\n\n.progress-description-container .block-after .panel-container .indicator {\n  background-color: var(--orange);\n}\n\n.progress-description-container .line-vertical {\n  background-color: var(--light-gray);\n  width: 1px;\n  margin: 0 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
